module.exports = __webpack_public_path__ + "static/media/3DPPA37.a6e714d3.jpg";